import Backbone from 'backbone';

import Forms from 'marionette.forms';

let PriceValidation = /^[0-9]+(\.[0-9]{2})?$/;
PriceValidation.message = 'Must be a valid amount';

let DateTimeValidation = {
 test(val){
   if(val == null) return true;
   return /^[0-9]{2}\/[0-9]{2}\/[0-9]{4} [0-9]{2}:[0-9]{2}:[0-9]{2}$/.test(val);
 },
 message: 'Valid date is required'
};

let DateValidation = {
 test(val){
   if(val == null) return true;
   return /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(val);
 },
 message: 'Valid date is required'
};

let NotNull = {
  test(value){
    if(value == undefined || value == null) return false;
    return true;
  }
};
NotNull.message = 'This field is required';

let QuantityValidation = {
  test(value, model){
    if(model.get('unspecified') == '1') return true;
    return NotNull.test(value);
  },
  message: NotNull.message
};

export default Forms.FormModel.extend({
  validation: {
    title: Forms.Required,
    tax: Forms.Required,
    description: Forms.Required,
    start_date: DateTimeValidation,
    end_date: DateValidation,
    amount: {
      test(value, model){
        if(model.get('unspecified') == '1') return true;
        return PriceValidation.test(value);
      },
      message: PriceValidation.message
    },
    minimum_amount: {
      test(value, model){
        if(model.get('unspecified') == '0') return true;
        return PriceValidation.test(value);
      },
      message: PriceValidation.message
    },
    recurring: NotNull,
    settlement_account: Forms.Required,
    costcentre: Forms.Required,
    unlimited_quantity: NotNull,
    unspecified: NotNull,
    quantity_setting: QuantityValidation,
    minimum_quantity: QuantityValidation,
    maximum_quantity: QuantityValidation
  },

  url(){
    if(this.get('id')){
      return '/joinos/api/offers/' + this.get('id');
    } else{
      return '/joinos/api/offers/new';
    }
  },

  parse(i){
    i['documents'] = new Backbone.Collection(i['documents']);
    i['quantity_setting'] = 'minimum';
    if(i['minimum_quantity'] == i['maximum_quantity']){
      i['quantity_setting'] = 'exact';
    }
    return i;
  },

  defaults: {
    documents: new Backbone.Collection(),
    title: '',
    description: '',
    gift_aid: false,
    consent_required: false,
    mandatory_offer: false,
    is_active: false,
    end_date: ''
  }
});



// WEBPACK FOOTER //
// ./offers/models/offer.js